import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { GridDetails, GridData, GridEvent } from '../interfaces/grid';
import { UrlBuilder } from '../../../core';
import { ActivityLogger } from '../../../activities/activity-logger';
import { IBreadcrumb, BreadcrumbService } from '../../shared/breadcrumb-service/breadcrumb.service';
import { SubjectSearchService } from './subject-search-service';
import { SubjectSearchData, SubjectSearchRequest, VisitSampleListRequest } from '../interfaces/subject-search-data';
import { LocalStorage } from '@ng-idle/core';
import { FilterSamplesInfo } from '../../filter-samples/filter-samples-info';
import { SampleStatusService } from '../../dashboard/overview-dashboard/sample-status/sample-status-service';
import { SelectedFilter, FilterNames, DbFilterNames } from '../../dashboard/overview-dashboard/dashboard-info';
import { SamplesHelperService } from '../../filter-samples/service/samples-helper-service';

@Component({
    selector: 'subject-search-overview',
    template: require('./subject-search-overview.component.html'),
    styles: [require('./subject-search-overview.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubjectSearchOverviewComponent {

    public sampleSearchData: SubjectSearchData[] = [];
    public gridDetails: GridDetails;
    public isLoadingCompleted = false;
    public resultCount = 0;
    public pagePerItems = [15, 25, 50, 75, 100, 250, 500];
    public emptyPlaceholder = '';
    private filterSamplesInfo: FilterSamplesInfo;

    constructor(
        private sampleTrackingStorage: SampleTrackingStorage,
        private changeDectRef: ChangeDetectorRef,
        private urlBuilder: UrlBuilder,
        private activityLogger: ActivityLogger,
        private breadcrumbService: BreadcrumbService,
        private subjectSearchService: SubjectSearchService,
        private statusService: SampleStatusService,
        private sampleHerlperServcie: SamplesHelperService
    ) {
        let requestData = localStorage.getItem('subjectSearchRequest');
        if (!requestData) { return; }
        let subjectRequestData: SubjectSearchRequest = JSON.parse(requestData);
        let routerUrl: IBreadcrumb = {
            label: 'Patient Number Search - ' + subjectRequestData.patientNumber,
            url: this.urlBuilder.esa().sampletracking().subjectSearchResults(subjectRequestData.patientNumber).url()
        };
        this.breadcrumbService.AddRouterToBreadCrumb(routerUrl);
        this.sampleTrackingStorage.subjectSearchResults(subjectRequestData).subscribe((results: SubjectSearchData[]) => {
            this.sampleSearchData = results;
            this.gridDetails = { header: this.subjectSearchService.subjectIDSearchHeader, data: results };
            this.isLoadingCompleted = true;
            this.resultCount = results.length > 0 ? results.length : this.resultCount;
            if (results.length === 0) {
                this.emptyPlaceholder = 'No results found for Patient Number - ' + subjectRequestData.patientNumber;
            }
            this.changeDectRef.markForCheck();
        });
        activityLogger.logActivity('Access Subject Details');
    }

    public onGridItemClick($event: GridEvent) {
        if ($event.header.key === 'patientNumber') {
            return;
        }
        let data: VisitSampleListRequest = {
            patientId: $event.data.patientId,
            patientNumber: $event.data.patientNumber,
            data: $event.data
        };
        localStorage.setItem('visitSampleListRequest', JSON.stringify(data));
        if ($event.header.key === 'visits') {
            this.urlBuilder.esa().sampletracking().subjectVisitDetails($event.data.patientNumber).navigate();
            return;
        }
        let listViewData = localStorage.getItem('listViewData');
        if (!listViewData) { return; }
        this.filterSamplesInfo = JSON.parse(listViewData);
        let allSamplesList = this.statusService.getAllSamplesStatusInfo();
        allSamplesList.filterItem.filterByPatient = { id: data.patientId, value: data.patientNumber };
        this.filterSamplesInfo.selectedStatus = allSamplesList.filterItem;
        let selectedFilters: SelectedFilter[] = [];
        this.sampleHerlperServcie.addSelectedItems([{ id: $event.data.protocolId, value: $event.data.protocolCode }], FilterNames.protocol, selectedFilters, DbFilterNames.protocol);
        this.sampleHerlperServcie.addSelectedItems([{ id: $event.data.subprotocolId, value: $event.data.projectNumber }], FilterNames.project, selectedFilters, DbFilterNames.project);
        this.sampleHerlperServcie.addSelectedItems([{ id: $event.data.countryId, value: $event.data.country }], FilterNames.country, selectedFilters, DbFilterNames.country);
        this.sampleHerlperServcie.addSelectedItems([{ id: $event.data.investigatorSitelId, value: $event.data.investigatorNumber + ' - ' + $event.data.investigatorName }],
                                                   FilterNames.investigatorNum, selectedFilters, DbFilterNames.investigatorNum);
        this.filterSamplesInfo.selectedFilterItems = selectedFilters;
        localStorage.setItem('listViewData', JSON.stringify(this.filterSamplesInfo));
        if (this.filterSamplesInfo.selectedStudyGroup) {
            this.urlBuilder.esa().sampletracking().studyGroup(this.filterSamplesInfo.selectedStudyGroup).filterSamples(this.filterSamplesInfo.selectedStatus.key).navigate();
        } else {
            this.urlBuilder.esa().sampletracking().protocolInfo(this.filterSamplesInfo.selectedProtocol$).filterSamples(this.filterSamplesInfo.selectedStatus.key).navigate();
        }
    }
}